import React, { useEffect } from 'react';
import Header from "../../components/Header/Header";
import Coach from "../../components/Coach/Coach";
import CoachForm from "../../components/CoachForm/CoachForm";
import { useDispatch, useSelector } from "react-redux";
import { getCoachesSagaAction } from "../../redux/sagaActions";
import CoachHeader from "../../components/PagesHeaders/CoachHeader/CoachHeader";

const Coaches = () => {
    const dispatch = useDispatch();
    const currentEstablishment = useSelector(state => state.currentEstablishment);
    const coaches = useSelector(state => state.coaches);

    // Получение списка тренеров
    useEffect(() => {

        if (!currentEstablishment) return;

        dispatch(getCoachesSagaAction());
    }, [currentEstablishment]);

    return (
        <>
            <Header component={ <CoachHeader/> }/>
            <CoachForm/>
            <div className="page">
                {
                    coaches.map(elem => {
                        return <Coach data={ elem } key={ elem.id } />
                    })
                }
            </div>
        </>
    );
};

export default Coaches;